// extracted by mini-css-extract-plugin
module.exports = {"widgetLoader":"Widget_widgetLoader__2ThRa"};